import React, { useState } from 'react';
import AdminDashboard from './AdminDashboard';
import UserManagement from './UserManagement';
import ProjectModeration from './ProjectModeration';
import FinancingManagement from './FinancingManagement';
import CfpDrafts from './CfpDrafts';
import {
  ChartBarIcon,
  UserGroupIcon,
  DocumentTextIcon,
  ChatBubbleLeftRightIcon,
  CurrencyDollarIcon,
  BanknotesIcon,
  Cog6ToothIcon,
  ShieldCheckIcon,
  BellIcon,
  InboxArrowDownIcon
} from '@heroicons/react/24/outline';

const Admin = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  const tabs = [
    { id: 'dashboard', name: 'Tableau de Bord', icon: ChartBarIcon },
    { id: 'users', name: 'Utilisateurs', icon: UserGroupIcon },
    { id: 'projects', name: 'Modération Projets', icon: DocumentTextIcon },
    { id: 'financing', name: 'Catalogue de financement', icon: BanknotesIcon },
    { id: 'cfp-drafts', name: 'Appels à valider', icon: InboxArrowDownIcon },
    { id: 'messages', name: 'Support Client', icon: ChatBubbleLeftRightIcon },
    { id: 'finance', name: 'Finance', icon: CurrencyDollarIcon },
    { id: 'settings', name: 'Paramètres', icon: Cog6ToothIcon }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <AdminDashboard />;
      case 'users':
        return <UserManagement />;
      case 'projects':
        return <ProjectModeration />;
      case 'financing':
        return <FinancingManagement />;
      case 'cfp-drafts':
        return <CfpDrafts />;
      case 'messages':
        return <SupportManagement />;
      case 'finance':
        return <FinanceManagement />;
      case 'settings':
        return <AdminSettings />;
      default:
        return <AdminDashboard />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header Admin */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-text">Administration</h1>
              <p className="text-gray-600 mt-1">Gestion de la plateforme Bourse d'Idées</p>
            </div>
            <div className="flex items-center space-x-4">
              <div className="flex items-center px-3 py-1 bg-red-100 text-red-800 rounded-full text-sm font-medium">
                <ShieldCheckIcon className="h-4 w-4 mr-1" />
                Mode Admin
              </div>
              <button className="flex items-center px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors">
                <BellIcon className="h-5 w-5 mr-2" />
                Notifications
              </button>
            </div>
          </div>
        </div>

        {/* Navigation Tabs */}
        <div className="mb-8">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8 overflow-x-auto">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center whitespace-nowrap ${
                      activeTab === tab.id
                        ? 'border-primary-500 text-primary-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <Icon className="h-5 w-5 mr-2" />
                    {tab.name}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Tab Content */}
        {renderTabContent()}
      </div>
    </div>
  );
};

// Composant pour le support client
const SupportManagement = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 className="text-xl font-semibold text-text mb-4">Support Client</h2>
        <div className="text-center py-12">
          <ChatBubbleLeftRightIcon className="h-16 w-16 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-600">Module de support client en cours de développement</p>
        </div>
      </div>
    </div>
  );
};

// Composant pour la gestion financière
const FinanceManagement = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 className="text-xl font-semibold text-text mb-4">Gestion Financière</h2>
        <div className="text-center py-12">
          <CurrencyDollarIcon className="h-16 w-16 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-600">Module de gestion financière en cours de développement</p>
        </div>
      </div>
    </div>
  );
};

// Composant pour les paramètres admin
const AdminSettings = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 className="text-xl font-semibold text-text mb-4">Paramètres Administrateur</h2>
        <div className="text-center py-12">
          <Cog6ToothIcon className="h-16 w-16 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-600">Module de paramètres en cours de développement</p>
        </div>
      </div>
    </div>
  );
};

export default Admin;

